import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
function SectionTitle({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(SectionTitleStyled, {
    ...props,
    children
  });
}
const SectionTitleStyled = styled.div.withConfig({
  displayName: "SectionTitleStyled",
  componentId: "sc-oyebvv-0"
})(["", " overflow:hidden;padding:", " ", " ", ";color:", ";text-overflow:ellipsis;white-space:nowrap;"], textStyles.uiTextS, token.spacing4, token.spacing5, token.spacing3, token.colorText);
export {
  SectionTitle
};
//# sourceMappingURL=SectionTitle.js.map
